<script lang="ts" setup></script>

<template>
  <main class="xs:px-3 mx-auto my-6 max-w-7xl px-4 md:px-5 lg:px-6 xl:my-5 xl:px-7 2xl:px-8">
    <slot></slot>
  </main>
</template>

<style lang="css" scoped></style>
